/** One content-free UUID per user-recognizable AI action. */
export function newAiOperationId(cryptoApi = typeof window !== 'undefined' ? window.crypto : undefined) {
  if (cryptoApi?.randomUUID) return cryptoApi.randomUUID();
  const bytes = new Uint8Array(16);
  if (cryptoApi?.getRandomValues) {
    cryptoApi.getRandomValues(bytes);
  } else {
    // Operation IDs are correlation/idempotency hints, not credentials. This compatibility
    // path keeps old/instrumented browsers from losing the user action; backend identity
    // collision handling remains authoritative.
    for (let index = 0; index < bytes.length; index += 1) {
      bytes[index] = Math.floor(Math.random() * 256);
    }
  }
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = [...bytes].map((b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export function aiOperationHeaders(operationId = newAiOperationId()) {
  return {
    'X-AI-Operation-Id': operationId,
    'X-AI-Source-Idempotency-Key': `frontend:${operationId}`,
    'X-AI-Logical-Run-Id': `frontend:${operationId}`,
  };
}
